import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { deleteTrackSheet } from "./store/trackSheetSlice";
import { FaFileExcel } from "react-icons/fa";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TrackSheetDataTable = ({ data, loading }) => {
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const dispatch = useDispatch();

  const { successMessage, error } = useSelector(state => state.trackSheetData);

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
    }
    if (error) {
      toast.error(error);
    }
  }, [successMessage, error]); 
  
  const handleDelete = (employeeId) => {
    dispatch(deleteTrackSheet(employeeId));
    setDeleteModalOpen(false); 
   };

  const columns = [
    // {
    //   title: "Name",
    //   dataIndex: `${"first_name"}`,
    //   render: (text, record) => (
    //     <div className="table-avatar">
    //       {/* <Link to="/profile" className="avatar">
    //         <img alt="" src={record.image} />
    //       </Link> */}
    //       <Link to="/profile">{text}</Link>
    //     </div>
    //   ),
    // },
    {
      title: "Sheet Type",
      dataIndex: "sheet_type",
    },
    {
      title: "Error",
      dataIndex: "error",
      render: (text) => {
        const truncatedText = text?.length > 50 ? text?.substring(0, 50) + "..." : text; 
        
        return (
          <div style={{ whiteSpace: "normal", wordWrap: "break-word", maxWidth: "200px" }}>
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id="tooltip-error">{text}</Tooltip>} 
            >
              <span>{truncatedText}</span>
            </OverlayTrigger>
          </div>
        );
      },
    },
    // {
    //   title: "Sheet",
    //   dataIndex: "sheet",
    // },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => {
        // Define the badge color based on status
        const badgeClass =
          text.toLowerCase() === "success"
            ? "badge bg-inverse-success" // Green for success
            : text.toLowerCase() === "error"
            ? "badge bg-inverse-danger"  // Red for error
            : "badge bg-inverse-secondary"; // Default color
    
        return <span className={badgeClass}>{text}</span>;
      },
    },
    {
      title: "Created At",
      dataIndex: "created_at",
    },
    {
      title: "Download",
      dataIndex: "sheet",
      render: (sheetPath) => (
        <a
          href={sheetPath}
          download
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFileExcel style={{ fontSize: '1.5rem', color: '#4CAF50' }} />
        </a>
      ),
    }
    // {
    //   title: "Action",
    //   render: (text, record) => (
    //     <div className="dropdown dropdown-action text-start">
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">
    //         {/* <Link
    //           className="dropdown-item"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#edit_user"
    //         >
    //           <i className="fa fa-pencil m-r-5" /> Edit
    //         </Link> */}
    //         <Link
    //           className="dropdown-item"
    //           to="#"
    //           onClick={() => {
    //             setSelectedEmployeeId(record.id);
    //             setDeleteModalOpen(true);
    //           }}
    //         >
    //           <i className="fa fa-trash m-r-5" /> Delete
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    // },
  ];

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="table-responsive">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            rowKey="id"
            // pagination={{ pageSize: 10 }}
          />
          {/* {isModalOpen && (
            <AddEmployeerComponent
              show={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              userId={selectedEmployeeId}
            />
          )} */}

          {/* {deleteModalOpen && (
            <DeleteModal
              onConfirm={() => handleDelete(selectedEmployeeId)}
              onCancel={() => setDeleteModalOpen(false)}
              Name="EmployeerComponent"
            />
          )} */}
        </div>
      </div>
    </div>
  );
};

export default TrackSheetDataTable;
